import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ProjectDealsSidebar from './sidebar';

import './styles.scss';

export default function ProjectDealsSidebarContainer({ deals }) {
  const [show, setShow] = useState(false);

  return (
    <div className="project-deals-sidebar-container">
      <div aria-label="openDealsSidebar" className="project-deals-sidebar-pulltab" onClick={() => setShow(true)}>
        <FontAwesomeIcon icon={faCaretUp}/>
      </div>
      <ProjectDealsSidebar deals={deals} show={show} onHide={() => setShow(false)}/>
    </div>
  );
}

ProjectDealsSidebarContainer.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.object),
};
